<div class="carousel-container">
  <div class="{{ ngxClass }}">
    <ng-content></ng-content>
  </div>
  <ng-container *ngIf="options.showNavigation">
    <figure class="nav-btn prev" (click)="prevSlide()">
      <ng-container *polymorpheusOutlet="customPrevIconContent || defaultArrow"></ng-container>
    </figure>
    <figure class="nav-btn next" (click)="nextSlide()">
      <ng-container *polymorpheusOutlet="customNextIconContent || defaultArrow"></ng-container>
    </figure>
  </ng-container>

  <ng-template #defaultArrow>
    <img src="https://images.cf-rabota.com.ua/alliance/carousel-arrow.svg" height="20px" width="20px" alt="prev slid" loading="eager" />
  </ng-template>

  <ng-container *ngIf="showPaginator$ | async">
    <div class="paginator">
      <i *ngFor="let i of instance?.innerElements || []; trackBy: trackByIndex; let index = index" (click)="onGoTo(index)" [class.active]="index === (currentSlide$ | async)"> </i>
    </div>
  </ng-container>
</div>
